<form [formGroup]="form">
    <mat-slide-toggle [color]="color" [checked]="checked"  [formControlName]="controlName" [innerHtml]="label  | HTMLFormatter">
      
    </mat-slide-toggle>
</form>
